import { matchPath, useNavigate } from "react-router-dom";

import { hasGeneralAccess } from "~/common/utils/checkUserPermissions";
import { useGetCurrentTeamMember, useIsTeamMemberStaff } from ".";
import { ROUTES } from "../router";

interface ProviderSettingsMenuOptions {
  label: string;
  onClick: () => void;
  enabled: boolean;
  current?: boolean;
}

export const useGetSettingsLayoutMenuOptions = () => {
  const navigate = useNavigate();
  const { isStaff } = useIsTeamMemberStaff();
  const { data: teamMember } = useGetCurrentTeamMember();
  const userPermissions = teamMember?.user_permissions ?? [];

  const actualPath = window.location.pathname;

  const menuOptions: ProviderSettingsMenuOptions[] = [
    {
      label: "Profile",
      onClick: () => {
        navigate(ROUTES.profile);
      },
      current: !!matchPath(ROUTES.profile, actualPath),
      enabled: true,
    },
    {
      label: "Care Plans",
      onClick: () => {
        navigate(ROUTES.carePlans);
      },
      current: !!matchPath(ROUTES.carePlans, actualPath),
      enabled: !isStaff && hasGeneralAccess(userPermissions),
    },
  ];

  return { menuOptions };
};
